import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import ReactBSAlert from "react-bootstrap-sweetalert";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import FilterList from "@material-ui/icons/FilterList";
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";
import Collapse from "@material-ui/core/Collapse";
import GetApp from "@material-ui/icons/GetApp";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import dateFormat from "dateformat";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import FormControl from "@material-ui/core/FormControl";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import DatePicker from "react-datepicker";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";

import {
  getSubscriptions,
  getAllSubscriptionStatus,
  bulkUpdateOrderStatus,
} from "../../network/ApiAxios";
import { redirectToLogout, parseWashingFeatures,zeroFill,dateSortFunc,
//  numericSortFunc,slotDateSortFunc
 } from "common/SharedFn";

 import Receipt from "@material-ui/icons/Receipt";
import { numericSortFunc } from "common/SharedFn";
import { Money } from "@material-ui/icons";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage:50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const SubscriptionsTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  // Filters open on request rather than always taking a row
  const [showFilters, setShowFilters] = useState(false);
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [success, setSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [activeOnly, setActiveOnly] = useState(1);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [id, setId] = useState();
  const [updateStatusModal, setUpdateStatusModal] = useState(false);
  const [executeStatusUpdate, setExecuteStatusUpdate] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  const [newStatus, setNewStatus] = useState(1);
  const [ids, setIds] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    style: { backgroundColor: "#c8e6c9" },
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect) {
        ids.push(row.id);
      } else {
        var index = ids.indexOf(row.id);
        if (index !== -1) {
          ids.splice(index, 1);
        }
      }
      setSelectedCount(ids.length);
    },
    onSelectAll: (isSelect, rows, e) => {
      if (isSelect) {
        for (var i = 0; i < rows.length; i++) {
          ids.push(rows[i].id);
        }
      } else {
        for (var i = 0; i < rows.length; i++) {
          var index = ids.indexOf(rows[i].id);
          if (index !== -1) {
            ids.splice(index, 1);
          }
        }
      }
      setSelectedCount(ids.length);
    },
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const accessAllOrdersPage = () => {
    let history = createHistory();
    history.push("/admin/orders/subscription");
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };
  const accessOrderPage = (id) => {
    let history = createHistory();
    history.push("/admin/orders/subscription/" + id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };
  const accessPaymentPage = (id) => {
    let history = createHistory();
    history.push("/admin/subscriptions/payment/" + id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const accessOrdersReport = () => {
    let history = createHistory();
    history.push("/admin/subscriptions/orders-report");
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };
  const clearCurrentRecord = () => {
    setNewStatus(1);
    setId();
  };

  const fetchSubscriptions = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    setData([]);
    try {
      const response = await getSubscriptions(startDate, endDate,activeOnly);
      const { data } = response;
      const responseStatusList = await getAllSubscriptionStatus();
      if (data.result.isSuccess) {
        setStatusList(responseStatusList.data.data);
        setData(data.data.map((prop) => makeTableRow(prop)));
        //setError("");
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    } catch (ex) {
      showErrorNotification("Failed to fetch subscriptions "+ex);
    }
    setIsLoading(false);
  };

  const bulkUpdateStatusAction = async () => {
    setExecuteStatusUpdate(false);
    setIsLoading(true);
    try {
      const response = await bulkUpdateOrderStatus(ids, newStatus);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Status Updated Successfully");
        setUpdateStatusModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
      showErrorNotification("Failed to update status");
      setIsLoading(false);
    }
  };

  useAsyncEffect(async () => {
    if (endDate == null) {
      var endDateStored = localStorage.getItem("searchEndDate");
      if(endDateStored != null && endDateStored.toUpperCase() !== "NULL"){
        setEndDate(new Date(endDateStored));
      }
      else{
        setEndDate(new Date());
      }
    }
    if (startDate == null) {
      var startDateStored = localStorage.getItem("searchStartDate");
      if(startDateStored != null && startDateStored.toUpperCase() !== "NULL"){
        setStartDate(new Date(startDateStored));
      }
      else{
        setStartDate(new Date().setDate(new Date().getDate() - 7));
      }
    }
    // if (activeOnly == null) {
      var searchActiveOnly = localStorage.getItem("searchActiveOnly");
      if(searchActiveOnly != null){
        setActiveOnly(searchActiveOnly);
      }
    //   else{
    //     setActiveOnly(1);
    //   }
    // }
      if (startDate != null && endDate != null  && activeOnly != null) {
        fetchSubscriptions();
      }
  }, [
    forceRefresh,
    executeStatusUpdate,
    startDate,
    endDate,
    activeOnly
  ]);

  const makeTableRow = (info) => {
    info = parseWashingFeatures(info);
    info.placedOnText = dateFormat(
      new Date(info.placedOn),
      "d-mmm-yyyy hh:MM TT"
    );
    if(info.placedOnText != null && info.placedOnText != ""){
      info.placedOnSplittedText = dateFormat(
        new Date(info.placedOn),
        "d-mmm-yyyy hh:MMTT"
      ).split(" ");
    }
    info.lastOrderPickupDateText = dateFormat(
      new Date(info.lastOrderPickupDate),
      "d-mmm-yyyy"
    );
    info.numberOfPickupsReminaing = 0;
    info.numberOfPickupsCompleted = 0;
    info.numberOfDropoffsReminaing = 0;
    info.numberOfDropoffsCompleted = 0;

    if(info.ordersById != null){
      for(var i = 0;i<info.ordersById.length;i++){
          if((info.ordersById[i].status > 0 && info.ordersById[i].status < 3) || info.ordersById[i].status === 8){
            info.numberOfPickupsReminaing = info.numberOfPickupsReminaing + 1;
          }
          else if(info.ordersById[i].status >= 3 && info.ordersById[i].status !== 10){
            info.numberOfPickupsCompleted = info.numberOfPickupsCompleted + 1;
          }
          if((info.ordersById[i].status > 0 && info.ordersById[i].status < 7) || info.ordersById[i].status === 9){
            info.numberOfDropoffsReminaing = info.numberOfDropoffsReminaing + 1;
          }
          else if(info.ordersById[i].status === 7){
            info.numberOfDropoffsCompleted = info.numberOfDropoffsCompleted + 1;
          }
      }
    }

    info.numberOfRenewals = 0;
    info.feeRounded = 0;
    info.feeVatRounded = 0;
    info.feeWithVatRounded = 0;
    info.net = 0;
    info.priceWithoutDiscountAndVat = 0;
    info.amount = 0;
    info.discountedAmount = 0;
    info.vatFormatted = 0;
    info.discountAmount = 0;
    if(info.subscriptionPaymentsById != null ){
      for(var i = 0;i<info.subscriptionPaymentsById.length;i++){
        if(info.subscriptionPaymentsById[i].isSuccess === 1){
          info.numberOfRenewals = info.numberOfRenewals + 1;
          info.amount = info.amount + info.subscriptionPaymentsById[i].finalPrice;
          info.priceWithoutDiscountAndVat = info.priceWithoutDiscountAndVat + (info.subscriptionPaymentsById[i].price - info.subscriptionPaymentsById[i].discountAmount);
          info.discountedAmount = info.discountedAmount + (info.subscriptionPaymentsById[i].finalPrice - info.subscriptionPaymentsById[i].vat);
          info.vatFormatted  = info.vatFormatted + info.subscriptionPaymentsById[i].vat;
          info.discountAmount = info.discountAmount + info.subscriptionPaymentsById[i].discountAmount;
          if(info.subscriptionPaymentsById[i].transactionDetailByTransactionId != null){
            if(info.subscriptionPaymentsById[i].transactionDetailByTransactionId.fee != null){
              info.feeRounded = info.feeRounded + info.subscriptionPaymentsById[i].transactionDetailByTransactionId.fee;
            }
            if(info.subscriptionPaymentsById[i].transactionDetailByTransactionId.feeVat != null){
              info.feeVatRounded = info.feeVatRounded + info.subscriptionPaymentsById[i].transactionDetailByTransactionId.feeVat;
            }
            if(info.subscriptionPaymentsById[i].transactionDetailByTransactionId.feeWithVat != null){
              info.feeWithVatRounded = info.feeWithVatRounded + info.subscriptionPaymentsById[i].transactionDetailByTransactionId.feeWithVat;
            }
            if(info.subscriptionPaymentsById[i].transactionDetailByTransactionId.feeWithVat != null){
              info.net = info.net + (info.subscriptionPaymentsById[i].finalPrice - (info.subscriptionPaymentsById[i].transactionDetailByTransactionId.feeWithVat));
            }
          }
        }
      }
    }
    info.feeRounded = info.feeRounded.toFixed(3);
    info.feeVatRounded = info.feeVatRounded.toFixed(3);
    info.feeWithVatRounded = info.feeWithVatRounded.toFixed(3);
    info.net = info.net.toFixed(3);
    info.priceWithoutDiscountAndVat = info.priceWithoutDiscountAndVat.toFixed(3);
    info.amount = info.amount.toFixed(3);
    info.discountedAmount = info.discountedAmount.toFixed(3);
    info.vatFormatted = info.vatFormatted.toFixed(3);
    info.discountAmount = info.discountAmount.toFixed(3);
    info.numberOfRenewals = info.numberOfRenewals - 1;
    if(info.numberOfRenewals<0){
      info.numberOfRenewals = 0;
    }
    return {
      ...info,
      idForm: (
        "S"+zeroFill(info.id,5)
      ),
      userIdForm: (
        "C"+zeroFill(info.userId,5)
      ),
      packageIdForm: (
        "R"+zeroFill(info.packageId,5)
      ),
      dayOfWeek: days[ new Date(info.placedOn).getDay() ],
      username: info.userByUserId.firstName + " " + info.userByUserId.lastName,
      isAutoRenewText: info.isAutoRenew === 1 ? "Yes" : "No",
      isFrozenText: info.isFrozen === 1 ? "Yes" : "No",
      frequencyText: info.subscriptionPackageByPackageId.frequency === 2 ? "Twice a week" : "Weekly",
      bags: "Up to "+info.subscriptionPackageByPackageId.upToBags,
      actions: (
        <div className="actions-right">
          <Tooltip title="View Orders">
            <Button
              size="small"
              classes={{
                root: classes.buttonContainedWarning,
              }} 
              variant="contained" 
              onClick={() => {
                accessOrderPage(info.id);
              }}
            >
              <Box component={Receipt} />
            </Button>
          </Tooltip>
          <div style={{ display: "inline-block" }}>
          <Tooltip title="View Payments">
            <Button
              size="small"
              classes={{
                root: classes.buttonContainedSuccess,
              }} 
              variant="contained" 
              style={{ marginLeft: "5px" }}
              onClick={() => {
                accessPaymentPage(info.id);
              }}
            >
              <Box component={Money} />
            </Button>
          </Tooltip>
          </div>
        </div>
      ),
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>


              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "idForm",
                    text: "ID",
                    sort: true,
                  },
                  {
                    dataField: "username",
                    text: "User Name",
                    sort: true,
                  },
                  {
                    dataField: "userIdForm",
                    text: "User ID",
                    sort: true,
                  },
                  {
                    dataField: "userByUserId.mobileNumber",
                    text: "Mobile Number",
                    sort: true,
                  },
                  {
                    dataField: "placedOnText",
                    text: "Placed On",
                    sort: true,
                    csvExport: false,
                    sortFunc: dateSortFunc,                    
                  },
                  {
                    dataField: "dayOfWeek",
                    text: "Placed On Day of Week",
                    sort: true,
                    csvExport: true,      
                    headerStyle: {display : "none"},
                    style : {display : "none"}             
                  },
                  {
                    dataField: "placedOnSplittedText[0]",
                    text: "Placed On Date",
                    headerStyle: {display : "none"},
                    style : {display : "none"}                 
                  },
                  {
                    dataField: "placedOnSplittedText[1]",
                    text: "Placed On Time",  
                    headerStyle: {display : "none"},
                    style : {display : "none"}         
                  },
                  {
                    dataField: "packageIdForm",
                    text: "Package ID",
                    sort: true,
                  },
                  {
                    dataField: "numberOfRenewals",
                    text: "Number of Renewals",
                    sort: true,
                  },
                  {
                    dataField: "frequencyText",
                    text: "Frequency",
                    sort: true,
                  },
                  {
                    dataField: "bags",
                    text: "Bags",
                    sort: true,
                  },
                  {
                    dataField: "amount",
                    text: "Price with VAT",
                    sort: true,
                    sortFunc: numericSortFunc,
                  },
                  {
                    dataField: "discountAmount",
                    text: "Discount",
                    sort: true,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  },
                  {
                    dataField: "discountedAmount",
                    text: "Discounted Price",
                    sort: true,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  },
                  {
                    dataField: "vatFormatted",
                    text: "VAT Order",
                    sort: true,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  },
                  {
                    dataField: "priceWithoutDiscountAndVat",
                    text: "Price",
                    sort: true,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  }, 
                  {
                    dataField: "feeRounded",
                    text: "PG Fees",
                    sort: true,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  },
                  {
                    dataField: "feeVatRounded",
                    text: "PG Fees VAT",
                    sort: true,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  },
                  {
                    dataField: "feeWithVatRounded",
                    text: "PG Fees With VAT",
                    sort: true,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  },
                  {
                    dataField: "net",
                    text: "Net",
                    sort: true,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  },
                  {
                    dataField: "paymentMethodByPaymentMethodId.name",
                    text: "Payment Method",
                    sort: true,
                  },
                  {
                    dataField: "lastOrderPickupDateText",
                    text: "Last Order Pickup Date",
                    sort: true,
                    csvExport: true,
                    sortFunc: dateSortFunc,                    
                  },
                  {
                    dataField: "isFrozenText",
                    text: "Is Frozen",
                    sort: true,
                  },
                  {
                    dataField: "isAutoRenewText",
                    text: "Is Auto Renew",
                    sort: true,
                  },
                  {
                    dataField: "subscriptionStatusByStatus.textEn",
                    text: "Status",
                    sort: true,
                  },
                  {
                    dataField: "numberOfPickupsReminaing",
                    text: "Pickups Remaining",
                    sort: true,
                    sortFunc: numericSortFunc,   
                  },
                  {
                    dataField: "numberOfPickupsCompleted",
                    text: "Pickups Completed",
                    sort: true,
                    sortFunc: numericSortFunc,   
                  },
                  {
                    dataField: "numberOfDropoffsReminaing",
                    text: "Dropoffs Remaining",
                    sort: true,
                    sortFunc: numericSortFunc,   
                  },
                  {
                    dataField: "numberOfDropoffsCompleted",
                    text: "Dropoffs Completed",
                    sort: true,
                    sortFunc: numericSortFunc,
                  },
                  {
                    dataField: "actions",
                    classes: "actions-col",
                    headerClasses: "actions-col",
                    text: "Actions",
                    csvExport: false,
                  },
                ]}
                search
                exportCSV
              >
                {(props) => (
                                    <>
                  <CardHeader
                    style={{ paddingTop: "0.875rem", paddingBottom: "0.875rem" }}
                    title={
                      <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Subscriptions</Box>
                    </Box>
                      </>
                    }
                    action={
                      <Box
                        display="flex" alignItems="center" flexWrap="wrap"
                        justifyContent="flex-end"
                        style={{ gap: 8, marginTop: 8, marginRight: 8 }}
                      >
                        <div
                          id="datatable-basic_filter"
                          style={{ display: "flex", alignItems: "center", height: 40 }}
                        >
                          <SearchBar
                            className="form-control-sm"
                            placeholder="Search..."
                            style={{ height: 40, margin: 0, boxSizing: "border-box" }}
                            {...props.searchProps}
                          />
                        </div>
<Tooltip
                          title="View All Subscription Orders"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedWarning,
                            }}
                            onClick={() => {
                              accessAllOrdersPage();
                            }}
                          >
                            <span>View All Subscription Orders</span>
                          </Button>
                        </Tooltip>

                        <Tooltip
                          title="View Orders Report"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedSuccess,
                            }}
                            onClick={() => {
                              accessOrdersReport();
                            }}
                          >
                            <span>View Orders Report</span>
                          </Button>
                        </Tooltip>
                        {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                        {/* </Tooltip> */}
                        <Tooltip title="Download CSV">
                          <span style={{ display: "flex" }}>
                            <ExportCSVButton
                              className="MuiButtonBase-root"
                              style={{
                                width: 40, height: 40, padding: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                border: "1px solid #172b4d", borderRadius: 8,
                                color: "#fff", backgroundColor: "#172b4d", cursor: "pointer",
                              }}
                              {...props.csvProps}
                            >
                              <GetApp style={{ width: 18, height: 18 }} />
                            </ExportCSVButton>
                          </span>
                        </Tooltip>
                        <Tooltip title={showFilters ? "Hide filters" : "Filters"}>
                          <IconButton
                            onClick={() => setShowFilters((open) => !open)}
                            aria-expanded={showFilters}
                            aria-label="Filters"
                            style={{
                              width: 40, height: 40,
                              border: "1px solid #dee2e6", borderRadius: 8,
                              color: showFilters ? "#5e72e4" : "#525f7f",
                              backgroundColor: showFilters ? "#eef0fb" : "transparent",
                            }}
                          >
                            <FilterList style={{ width: 18, height: 18 }} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    }
                  />
                  <div className="table-responsive">
                                        <Collapse in={showFilters}>
                      <Divider />
                      <Grid container className="pl-4">
                      <Grid item xs={12} sm={12}>
                        <form>
                          View by Placed On From 
                          <div style={{ display: "inline-block" }}>
                            <DatePicker
                              timeCaption="Start Date"
                              selected={startDate}
                              customInput={<OutlinedInput />}
                              onChange={(date) => {
                                localStorage.setItem("searchStartDate", date);
                                setStartDate(date);}}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>
                           to 
                          <div style={{ display: "inline-block" }}>
                            <DatePicker
                              timeCaption="End Date"
                              selected={endDate}
                              customInput={<OutlinedInput />}
                              onChange={(date) => {
                              localStorage.setItem("searchEndDate", date);
                                setEndDate(date);
                              }}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>
                          <div
                            style={{
                              display: "inline-block",
                              marginBottom: "20px",
                            }}
                          >
                            <Select
                              variant="outlined"
                              value={activeOnly}
                              onChange={(e) => {
                                localStorage.setItem("searchActiveOnly", e.target.value);
                                setActiveOnly(e.target.value);}}
                              IconComponent={KeyboardArrowDown}
                            >
                              <MenuItem value={1}>Successful only (Active/Frozen)</MenuItem>
                              <MenuItem value={0}>All Orders</MenuItem>
                            </Select>
                          </div>
                        </form>
                      </Grid>
                    </Grid>
                    </Collapse>
                    {selectedCount > 0 && (
                      <Grid container className="pl-4">
                      <Grid item xs={12} sm={12}>
                        <div
                            style={{
                              marginBottom: "20px",
                            }}
                          >
                        {selectedCount} Subscriptions Selected
                        </div>
                      </Grid>
                    </Grid>
                    )}
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      selectRow={selectRow}
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                  </div>
                  </>
                )}
              </ToolkitProvider>
            </Card>
          </Grid>
        </Grid>


        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={updateStatusModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setUpdateStatusModal(false)}
        >
          <DialogTitle disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>Update Status</h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <form>
              <FormGroup>
                <FormLabel>New Status</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    value={newStatus}
                    onChange={(e) => setNewStatus(e.target.value)}
                    IconComponent={KeyboardArrowDown}
                  >
                    {statusList.map(function (sts, i) {
                      return <MenuItem value={sts.id}>{sts.textEn}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </FormGroup>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setUpdateStatusModal(false)}>Cancel</Button>
            <Button
              onClick={() => bulkUpdateStatusAction()}
              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default SubscriptionsTable;
